import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';
import { Observable } from 'rxjs';
import { VApiService } from './vapi.service';

const VBC_HOSTS = new Map<Environment, string>();
VBC_HOSTS.set(Environment.LOCAL, 'vbc-demo.appspot.com');
VBC_HOSTS.set(Environment.DEMO, 'vbc-demo.appspot.com');
VBC_HOSTS.set(Environment.PROD, 'vbc-prod.appspot.com');

export interface VbcUser {
  firstName?: string;
  createdDateTime: string;
  lastLoginDateTime?: string;
  phoneNumber?: string;
  lastName?: string;
  email: string;
  unifiedUserId: string;
}

@Injectable({ providedIn: 'root' })
export class VbcApiService {
  private scheme = '';
  private vbcHost = '';

  constructor(
    private vapiService: VApiService,
    private environmentService: EnvironmentService,
  ) {
    this.scheme = window.location.protocol.startsWith('https') ? 'https' : 'http';
    this.vbcHost = VBC_HOSTS.get(environmentService.getEnvironment());
  }

  createAndAssociateUser(
    partnerId: string,
    accountGroupId: string,
    email: string,
    firstName?: string,
    lastName?: string,
    phone?: string,
    associatedCheck?: boolean,
  ): Observable<any> {
    return this.vapiService.post(`${this.scheme}://${this.vbcHost}/internalApi/v3/user/createAndAssociate/`, null, {
      params: {
        pid: partnerId,
        accountGroupId: accountGroupId,
        email: email,
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        preferredLocale: 'en-US',
        sendWelcomeEmailFlag: true,
        errorIfAlreadyAssociatedFlag: associatedCheck || false,
      },
    });
  }

  getUsersOnAccountGroup(partnerId: string, accountGroupId: string): Observable<VbcUser[]> {
    return this.vapiService.post(`${this.scheme}://${this.vbcHost}/internalApi/v3/user/lookupByAccountGroup/`, null, {
      params: {
        partnerId: partnerId,
        accountGroupId: accountGroupId,
      },
    });
  }
}
